import type { IGeolocalizationRes } from "~/types/api";
import type {
  IGeolocalization,
  IImpactCountry,
  IImpactReferrer
} from "~/types/components";

const GeoLocalizationsRes2GeoLocalizations = (
  geoLocalizations: IGeolocalizationRes[]
): IGeolocalization[] => {
  return geoLocalizations.map((geoLocalization) => ({
    longitude: parseFloat(geoLocalization.longitude),
    latitude: parseFloat(geoLocalization.latitude),
    amount: geoLocalization.amount
  }));
};

const CountriesToSeries = (
  countries: IImpactCountry[]
): Highcharts.PointOptionsObject[] => {
  return countries.map((country) => ({
    name: country.country,
    y: country.amount
  }));
};

const ReferrerToSeries = (
  referrers: IImpactReferrer[]
): Highcharts.PointOptionsObject[] => {
  return referrers.map((referrer) => ({
    name: referrer.referrer,
    y: referrer.amount
  }));
};
export {
  GeoLocalizationsRes2GeoLocalizations,
  CountriesToSeries,
  ReferrerToSeries
};
